import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const emailSuppressionReasonSchema = z.enum(["BOUNCE", "COMPLAINT"]);

export const MAX_EMAIL_SUPPRESSION_CHECKS = 20;

/**
 * Whether each address is on the SES account-level suppression list, which
 * blocks every SES send to it, merchant login codes included.
 */
export const getEmailSuppression = {
  name: "getEmailSuppression" as const,
  input: z.object({
    emails: z
      .array(z.string().trim().email())
      .min(1)
      .max(MAX_EMAIL_SUPPRESSION_CHECKS),
  }),
  output: z.object({
    results: z.array(
      z.object({
        email: z.string(),
        suppression: z
          .object({
            /** The casing SES stored, which removal must match exactly. */
            suppressedEmail: z.string(),
            reason: emailSuppressionReasonSchema,
            lastUpdatedAt: zExt.instant(),
          })
          .nullable(),
      }),
    ),
  }),
};
